import nodeStyles from '../constants/nodeStyles';
import timelineBuilder from './timelineBuilder';
import nodeIconBuilder from './nodeIconBuilder';
import nodeDescriptions from '../constants/nodeDescriptions';

export function decorateNodes(data) {
    const timelineNodes = timelineBuilder(data);
    const bagIconNodes = nodeIconBuilder(data);

    const mergedData = data.map((node) => {
        const nodeStatus = timelineNodes.find(
            (x) => x.sortOrder === node.sortOrder
        );

        const nodeIcon = bagIconNodes.find(
            (x) => x.sortOrder === node.sortOrder
        );

        return { ...node, ...nodeStatus, ...nodeIcon };
    });

    return mergedData;
}

export function createStationNodeClassName(modifier, showIcon) {
    return showIcon
        ? `station-node station-node--${modifier} station-node--with-icon`
        : `station-node station-node--${modifier}`;
}

const nodeDescriptionsWithIcons = [
    nodeDescriptions.reflight,
    nodeDescriptions.flightCancelled,
];
function shouldShowIcon(description, isLastBagNode) {
    return isLastBagNode || nodeDescriptionsWithIcons.includes(description);
}

// eslint-disable-next-line complexity, max-statements
export function buildNodeClassName(node) {
    switch (node.style) {
        case nodeStyles.critical:
            return createStationNodeClassName(
                'critical',
                shouldShowIcon(node.description, node.isLastBagNode)
            );
        case nodeStyles.success:
        case nodeStyles.reflight:
            return createStationNodeClassName(
                'success',
                shouldShowIcon(node.description, node.isLastBagNode)
            );
        case nodeStyles.future:
            return createStationNodeClassName(
                'future',
                shouldShowIcon(node.description, node.isLastBagNode)
            );
        default:
            return createStationNodeClassName(
                'none',
                shouldShowIcon(node.description, node.isLastBagNode)
            );
    }
}

export function createConnectingLineClassName(modifier) {
    return `station-node__connecting-line station-node__connecting-line--${modifier}`;
}

// eslint-disable-next-line complexity
export function buildConnectingLineClassName(nodeStyle) {
    switch (nodeStyle) {
        case nodeStyles.success:
        case nodeStyles.critical:
        case nodeStyles.pickedUp:
            return createConnectingLineClassName('completed');
        case nodeStyles.future:
            return createConnectingLineClassName('future');
        case nodeStyles.void:
        case nodeStyles.reflight:
            return createConnectingLineClassName('void');
        default:
            return 'station-node__connecting-line';
    }
}
